export const unmask = (value) => {
  return value.replace(/[^\d]/g, '')
}

export const defaultMask = '+9-999-999-999-999'
